<template>
    <div style="overflow:hidden">
        <ContentHeader />
		<div v-if="loading" class="loading">
			<div class="loader"></div>
			<img src="@/assets/img/logo.jpg" alt="logo" width="496" height="99" class="loaderLogo">
		</div>
          <div class="slider-wrapper">
              <div class="slider-overlay">
                <img src="@/assets/img/logo.jpg" alt="Logo" class="slider-logo" />
                <h2>Elemax-Tech Engineering Company Limited</h2>
              </div>
            <VueSlickCarousel :arrows="true" :dots="true" :autoplay="true" :infinite="true">
              <div v-for="(image, index) in images" :key="index" class="slide">
                <img :src="image" alt="" />
                <div class="slide-overlay">
                  <h2>Elemax-Tech Engineering Company Limited</h2>
                </div>
              </div>
            </VueSlickCarousel>
          </div>
          <div class="block">
            <div class="ctInner">
              <h1 class="leadTitle" data-aos="fade-up">Types of Elevator We Provide</h1>
              <div class="type-cards">
                <div class="type-card" data-aos="fade-right">
                  <img src="@/assets/img/passenger-elevator.jpg" alt="Passenger Elevator" />
                  <h3>Passenger Elevator</h3>
                </div>
                <div class="type-card" data-aos="fade-right">
                  <img src="@/assets/img/Home-Elevator.png" alt="Home Elevator" />
                  <h3>Home Elevator</h3>
                </div>
                <div class="type-card" data-aos="fade-left">
                  <img src="@/assets/img/Hospital-Elevator.png" alt="Hospital Elevator" />
                  <h3>Hospital Elevator</h3>
                </div>
                <div class="type-card" data-aos="fade-left">
                  <img src="@/assets/img/freight-elevator.png" alt="Freight Elevator" />
                  <h3>Freight Elevator</h3>
                </div>
                <div class="type-card" data-aos="fade-right">
                  <img src="@/assets/img/panoramicelevator.png" alt="Panoramic Elevator" />
                  <h3>Panoramic Elevator</h3>
                </div>
                <div class="type-card" data-aos="fade-right">
                  <img src="@/assets/img/escalators.png" alt="Escalators" />
                  <h3>Escalators</h3>
                </div>
                <div class="type-card" data-aos="fade-left">
                  <img src="@/assets/img/moving_walk.png" alt="Moving Walkway" />
                  <h3>Moving Walkway</h3>
                </div>
                <div class="type-card" data-aos="fade-left">
                  <img src="@/assets/img/car-elevator.png" alt="Car Elevator" />
                  <h3>Car Elevator</h3>
                </div>
              </div>
            </div>
          </div>
          <div class="block bgGray">
            <div class="ctInner">
              <h1 class="leadTitle" data-aos="fade-up">About Us</h1>
              <div class="col">
                <div class="left" data-aos="fade-right">
                  <img src="@/assets/img/aboutus.jpg" alt="about us" />
                </div>
                <div class="right" data-aos="fade-left">
                  <p>Elemax-Tech Engineering Company Limited is a leading provider of vertical transportation solutions in Myanmar. We specialize in new lifts, elevators, and escalators, offering state-of-the-art technology and reliable performance for residential, commercial, and industrial buildings.</p>
                  <p>In addition to supplying new equipment, we provide comprehensive maintenance services to ensure the safety, efficiency, and longevity of all elevators and escalators. Our team of skilled technicians is dedicated to delivering prompt and professional support, keeping your systems running smoothly at all times.</p>
                  <p>We also supply high-quality spare parts, enabling fast repairs and minimizing downtime. At Elemax-Tech Engineering Company, we are committed to excellence, safety, and customer satisfaction, making us the trusted choice for vertical transportation in Myanmar.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="block">
            <div class="ctInner">
              <h1 class="leadTitle" data-aos="fade-up">Our Services</h1>
              <div class="col flip">
                <div class="left" data-aos="fade-right">
                  <img src="@/assets/img/services.jpg" alt="our services" />
                </div>
                <div class="right" data-aos="fade-left">
                  <p>Elemax-Tech Engineering Company Limited is a leading provider of vertical transportation solutions in Myanmar. We specialize in new lifts, elevators, and escalators, offering modern technology and reliable performance for residential, commercial, and industrial buildings.</p>
                  <p>Our comprehensive services include:</p>

                  <ul>
                    <li><span>Supply of New Equipment</span> – High-quality elevators, lifts, and escalators for various applications.</li>
                    <li><span>Installation Services</span> – Professional installation to ensure safety and efficiency.</li>
                    <li><span>Maintenance & Servicing</span> – Regular inspection, preventive maintenance, and prompt repairs to maximize system performance.</li>
                    <li><span>Spare Parts Supply</span> – Genuine spare parts for quick replacement and minimal downtime.</li>
                    <li><span>Modernization & Upgrades</span> – Upgrading older systems with the latest technology for improved safety and efficiency.</li>
                  </ul>

                  <p>At Elemax-Tech Engineering Company, we are committed to safety, reliability, and customer satisfaction, making us the trusted partner for vertical transportation solutions in Myanmar.</p>
                </div>
              </div>
            </div>
          </div>
        <ContentFooter />
    </div>
</template>

<script>
  import ContentHeader from '@/components/ContentHeader.vue'
  import ContentFooter from '@/components/ContentFooter.vue'
  import VueSlickCarousel from 'vue-slick-carousel';
  export default {
    name: 'HomePage',
    components: {
      ContentHeader,
      ContentFooter,
      VueSlickCarousel
    },
    data() {
      return {
        images: [
          require('@/assets/img/banner1.jpg'),
          require('@/assets/img/banner2.jpg'),
          require('@/assets/img/banner3.jpg'),
          require('@/assets/img/banner4.jpg'),
          require('@/assets/img/banner5.jpg')
        ],
		loading: true,
      };
    },
	mounted() {
		this.loading = false;
	}
  }
</script>